{
  "name": "idscan-go",
  "version": "11.0.0",
  "private": true,
  "dependencies": {
    "ajv": "^6.12.6",
    "axios": "^0.21.2",
    "axios-retry": "^3.1.2",
    "core-js": "^3.32.1",
    "envfile": "^2.3.0",
    "history": "^4.7.2",
    "i18next": "^23.4.6",
    "node-forge": "^1.3.1",
    "npm-run-all": "^4.1.5",
    "react": "^16.14.0",
    "react-device-detect": "^1.6.1",
    "react-dom": "^16.4.1",
    "react-i18next": "^13.2.1",
    "react-redux": "^5.0.7",
    "react-router-dom": "^4.3.1",
    "redux": "^4.0.0",
    "redux-persist": "^5.10.0",
    "redux-thunk": "^2.3.0"
  },
  "scripts": {
    "start:site": "node ./esbuild.mjs serve",
    "build:site": "NODE_ENV=production node ./esbuild.mjs build",
    "test:e2e": "node --preserve-symlinks e2e/run.mjs"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie <= 11",
    "not op_mini all"
  ],
  "devDependencies": {
    "@craftamap/esbuild-plugin-html": "^0.9.0",
    "dotenv": "^17.0.1",
    "esbuild": "^0.25.12",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-sass-plugin": "^3.3.1",
    "playwright-core": "^1.61.1",
    "sass-embedded": "^1.83.0"
  }
}
